import { Routes, Route, useNavigate, useLocation }
  from 'react-router-dom'
import Login from './Auth/Login';
import { history } from './_helpers'
import { Nav } from './Components/Nav';
import { PrivateRoute } from './Components/PrivateRoute';
import TranslationEditor from './Translations/TranslationEditor';
import DictionaryWordEditor from './Components/Dictionary/DictionaryWordEditor';
import VocabularyEditor from './Components/Vocabulary/VocabularyEditor';
import GrammarTopicsList from './Components/Grammar/GrammarTopicsList';
import GrammarTopicEditor from './Components/Grammar/GrammarTopicEditor';
import GrammarTopicViewer from './Components/Grammar/GrammarTopicViewer';
import PhrasesList from './Components/Phrases/PhrasesList';
import ShortStoryManager from './Components/ShortStory/ShortStoryManager';
import LongPostList from './Components/LongPost/LongPostList';
import LongPostChunkManager from './Components/LongPost/LongPostChunkManager';
import VideoPostList from './Components/VideoPost/VideoPostList';
import VideoPostTranscriptManager from './Components/VideoPost/VideoPostTranscriptManager';
import PlaylistManager from './Components/Playlist/PlaylistManager';
import PlaylistChildrenManager from './Components/Playlist/PlaylistChildrenManager';
import AlgorithmicProblemManager from './Components/AlgorithmicProblem/AlgorithmicProblemManager';
import AlgorithmicProblemContentManager from './Components/AlgorithmicProblem/AlgorithmicProblemContentManager';

function App() {
  // init custom history object to allow navigation from 
  // anywhere in the react app (inside or outside components)
  history.navigate = useNavigate();
  history.location = useLocation();

  return (
    <div>
      <Nav />

      <div>
        <Routes>
          <Route path="/login" element={<Login />} />
          
          {/* Protected Routes */}
          <Route
            path="/"
            element={
              <PrivateRoute>
                <ShortStoryManager />
              </PrivateRoute>
            }
          />
          <Route 
            path="/text/translate/:textId" 
            element={
              <PrivateRoute>
                <TranslationEditor />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/dictionary" 
            element={
              <PrivateRoute>
                <DictionaryWordEditor />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/vocabulary" 
            element={
              <PrivateRoute>
                <VocabularyEditor />
              </PrivateRoute>
            } 
          />

          <Route 
            path="/grammar" 
            element={
              <PrivateRoute>
                <GrammarTopicsList />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/grammar/create" 
            element={
              <PrivateRoute>
                <GrammarTopicEditor />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/grammar/edit/:id" 
            element={
              <PrivateRoute>
                <GrammarTopicEditor />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/grammar/topic/:slug" 
            element={
              <PrivateRoute>
                <GrammarTopicViewer />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/phrases" 
            element={
              <PrivateRoute>
                <PhrasesList />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/short-stories" 
            element={
              <PrivateRoute>
                <ShortStoryManager />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/long-posts" 
            element={
              <PrivateRoute>
                <LongPostList />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/long-posts/edit/:id" 
            element={
              <PrivateRoute>
                <LongPostChunkManager />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/video-posts" 
            element={
              <PrivateRoute>
                <VideoPostList />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/video-posts/edit/:id" 
            element={
              <PrivateRoute>
                <VideoPostTranscriptManager />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/playlists" 
            element={
              <PrivateRoute>
                <PlaylistManager />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/playlists/:id/children" 
            element={
              <PrivateRoute>
                <PlaylistChildrenManager />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/algorithmic-problems" 
            element={
              <PrivateRoute>
                <AlgorithmicProblemManager />
              </PrivateRoute>
            } 
          />
          <Route 
            path="/algorithmic-problems/edit/:id" 
            element={
              <PrivateRoute>
                <AlgorithmicProblemContentManager />
              </PrivateRoute>
            } 
          />
        </Routes>
      </div>
    </div>
  );
}

export default App;
